<template>
	<div>
		<button type="submit" class="btn btn-primary" @click.prevent="addcomment = !addcomment" v-if="!addcomment && !sent">{{ privtitle }}</button>
		<br>
		<span v-if="addcomment && !sent"> {{ privtitle }} <br></span>
		<div v-if="addcomment && !loggedin" style="margin-left:10px;font-size:0.8em;">
			{{ messages.hint_logon }} <a href="/login" style="font-size:1.2em;">{{ messages.login }}</a><br>{{ messages.login_warning }}
		</div>
		<textarea v-if="addcomment" v-model="comment" class="form-control bindchanged"></textarea>
		<div id="submittedcomment" v-if="submittedcomment">
			<div class="card">
				<div class="card-header shadow-sm">
					{{ messages.publish_success }}
				</div>
				<div class="card-body ">
					{{ submittedcomment }}
				</div>
			</div>
		</div>
		<div v-show="wait4approve" style="position:absolute;margin-top:-70px;margin-left:0px;z-index:3;padding:10px;width:330px;background-color:#fff;color:#333;border-radius: 5px;border:1px solid #ccc;opacity: 0.94;text-align:center">
			<h3 style="color:#222;">{{ messages.thank_you }}</h3>
		</div>
		<button type="submit" v-show="!sent" class="btn btn-primary" @click.prevent="addcomment = false" v-if="addcomment">{{ messages.cancel }}</button>
		<button type="submit" v-show="!sent" class="btn btn-primary" @click.prevent="createItem()" v-if="addcomment">{{ messages.publish }}</button>
	</div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import axios from 'axios';

const props = defineProps(['story_id', 'parent_id', 'title', 'loggedin', 'edit']);
const emit = defineEmits(['reset', 'submit']);

const addcomment = ref(false);
const comment = ref('');
const submittedcomment = ref('');
const wait4approve = ref(false);
const privtitle = ref(props.title);
const messages = window.messages;
const sent = ref(false);

watch(addcomment, (newVal) => {
	if (props.edit && newVal) {
		const commentElement = document.querySelector(`#comment_${props.parent_id}`);
		if (commentElement) {
			commentElement.style.display = 'none';
		}
	} else {
		const commentElement = document.querySelector(`#comment_${props.parent_id}`);
		if (commentElement) {
			commentElement.style.display = 'initial';
		}
	}
});

onMounted(() => {
	if (props.edit) {
		const txt = document.createElement('textarea');
		txt.innerHTML = props.edit.text;
		comment.value = txt.value;
		privtitle.value = messages.edit_feedback;
	}
});

const createItem = () => {
	sent.value = true;
	axios.post('/comments', {
		text: comment.value,
		story_id: props.story_id,
		parent_id: props.parent_id,
		edit: props.edit,
	})
		.then((res) => {
			wait4approve.value = true;
			setTimeout(() => {
				wait4approve.value = false;
			}, 5000);
			emit('reset');
			emit('submit', res.data);
			addcomment.value = false;
			if (props.edit) {
				location.reload();
				submittedcomment.value = 'Saved, reloading the page';
			} else {
				submittedcomment.value = comment.value;
			}
			comment.value = '';
			window.removeEventListener('beforeunload', () => {});
		})
		.catch((error) => {
			localStorage.setItem('model', JSON.stringify(props.story));
		});
};
</script>

<style scoped>
textarea {
	overflow: auto;
	resize: vertical;
	width: 100%;
	height: 200px;
}

#submittedcomment {
	margin-left: 40px;
}
</style>
